<template>
    <span class="SelectEditorRequest">
        <span v-if="CheckPermission(ViewPermissionRequirement)">
            {{ OldValueText }}
            <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
            <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer>
                <b-container>
                    <b-form @submit="Save">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Old Value:</label>
                                    <input class="form-control" v-model="OldValueText" disabled />
                                    <label>New Value:</label>
                                    <select class="form-control" v-model="NewValue" ref="showfocus" v-bind:required="Required">
                                        <option v-for="option in Options" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="Cancel()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>

                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
        <span v-else>
            PRIVATE
        </span>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "OldValue",
            "OldValueText",
            "PropertyName",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "Options",
            "EditPermission",
            "ViewPermissionRequirement",
            "ChartId"
        ],
        data: function () {
            return {
                NewValue: {}
            };
        },
        methods: {
            ShowEditModal() {
                this.NewValue = this.OldValue;
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", this.UpdateMethod, { Id: this.RecordId, [this.PropertyName]: this.NewValue }, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                let vm = this;
                vm.OldValue = vm.NewValue;
                vm.$refs['component-modal'].hide();
                //Perform Global Updates
                vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {

        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
        }
    }
</script>

<style scoped>
</style>